import React, { forwardRef } from "react";
import CCAHCalculationGrids from "../../components/Billing/CCAHCalculationGrids";

export type ChildRef = { detailsUpdated: boolean };

const CalculateTab = forwardRef<ChildRef>(({ invoiceInfo, parentCallback }: any, ref) => {
    return (
        <div style={{ paddingTop: "15px" }}>
            <CCAHCalculationGrids
                invoiceInfo={invoiceInfo}
                parentCallback={parentCallback}
                readOnly={false}
            />
        </div>
    );
});

export default CalculateTab;
